import { render, staticRenderFns } from "./Artwork.vue?vue&type=template&id=11001e30&scoped=true"
import script from "./Artwork.vue?vue&type=script&lang=js"
export * from "./Artwork.vue?vue&type=script&lang=js"
import style0 from "./Artwork.vue?vue&type=style&index=0&id=11001e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11001e30",
  null
  
)

export default component.exports